import _ from 'lodash';
import Swal from 'sweetalert2';
import '@popperjs/core';
import 'bootstrap';
import $ from 'jquery';
import Vue from 'vue';
window.Vue = Vue;

//import * as moment from 'moment';
//const moment = require('moment')
//require('moment/locale/de');

import * as moment from 'moment';
import 'moment/locale/de';
moment.locale('de');


require('vue2-animate/dist/vue2-animate.min.css');



window.jQuery = $;
window.$ = window.jQuery;
window.Swal = Swal;
window._ = _; // Lodash

window.axios = require("axios");

window.axios.defaults.withCredentials = true;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.access_token;

import StarRating from 'vue-star-rating';

//Vue.use(VCalendar);
//Vue.component('file-upload', VueUploadComponent);
//Vue.component('app-file-upload', Uploader);
//Vue.component('make-a-reservation', MakeReservation);
Vue.component('questionnaire', require('./frontend/components/Questionnaire.vue').default);
//Vue.component('questionnaire-overview', require('./backend/components/QuestionnaireOverview.vue').default);
Vue.component("star-rating", StarRating);

var VueScrollTo = require('vue-scrollto');

Vue.use(require('vue-moment'));

Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});

const app = new Vue({
    el: "#app"
});




// jquery stuff:

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});
$(function () {
    $('[data-toggle="popover"]').popover();
});

